import {t} from "../../../i18n";
import React, {useState} from "react";
import {copyToClipboard} from "../../deposit/DepositProviderContent";
import QRCode from "qrcode";
import {connect} from "react-redux";
import {AppState} from "../../../RootReducer";
import {Currency} from "../../../http/protocol";
import {Dispatch} from "redux";
import {initDeposit} from "../../../payments/DepositActions";
import Icon from "../../../core/ui/atoms/Icon";

interface CryptoQRProps {
    address : string;
}

interface Props {
    address : string;
    currencyCode : string;
    decimals : number;
    warningText : string;
    currencies? : Currency[];
    code?: string;
    generateNew? : boolean;
    initDeposit? : typeof initDeposit;
    customContext?: any;
}

export const CryptoDeposit = (props : Props) => {
    let currencyName:string = "";


    props.currencies && props.currencies.filter((curr) => {
        console.log(curr.code)
        if(curr.code === props.currencyCode) {
            currencyName = curr.name || "";
        }
    })
    //Remove Micro from currency name
    if(currencyName.toLowerCase().match('micro-')) {
        currencyName = currencyName.toLowerCase().split("micro-").join("");
        currencyName = currencyName.charAt(0).toUpperCase() + currencyName.slice(1)
    }
    //Remove Milli from currency name
    if(currencyName.toLowerCase().match('milli-')) {
        currencyName = currencyName.toLowerCase().split("milli-").join("");
        currencyName = currencyName.charAt(0).toUpperCase() + currencyName.slice(1)
    }

    if(props.customContext?.networkName) {
        currencyName = props.customContext?.networkName;
    }
    let currencyCode = props.currencyCode;
    if(props.customContext?.network) {
        currencyCode = props.customContext.network;
    }

    let currency = currencyName;
    if(props.customContext?.coinName) {
        currency = props.customContext.coinName;
    }

    let network = currencyCode;
    if(props.customContext?.token) {
        network = props.customContext?.token;
    } else if(props.customContext?.network) {
        network = props.customContext.network;
    }

    const [copied, setCopied] = useState(false);
    const [tagCopied, setTagCopied] = useState(false);
    return (
        <div className={"crypto-deposit-container"}>

            <div className={"text"}>
                {props.code == "BTC_LIGHTNING" && (
                    t("payments.btc-lightning-address", { currencyCode : currencyCode})
                )}
                {props.code != "BTC_LIGHTNING" && t("payments.address", { currencyName : currency, currencyCode : network })}
            </div>
            <div className="crypto-qr-container" onClick={() => {
                setCopied(true);
                copyToClipboard("cryptoAddress");}}>
                <CryptoQR address={props.address}/>
            </div>
            {props.customContext?.destinationTag && <span className={"crypto-address-label"}>{t("payments.deposit-address")}</span>}
            <div className={"crypto-address crypto-address-flash" }  onClick={()=> {
                    setCopied(true);
                    setTagCopied(false);
                    copyToClipboard("cryptoAddress");
                    setTimeout(() => {
                        setCopied(false);
                    }, 2000);
                }}>
                <span className={"address"} id={"cryptoAddress"}>{props.address}</span>
                <i className={"copy material-icons"}>content_copy</i>
            </div>
            {props.customContext?.destinationTag && (
                <>
                    <span className={"crypto-address-label"}>{t("payments.destination-tag")}</span>
                    <div className={"crypto-address crypto-address-flash" }>
                        <span className={"address"} id={"destinationTag"}>{props.customContext.destinationTag}</span>
                        <i className={"copy material-icons"} onClick={()=> {
                            setTagCopied(true);
                            setCopied(false);
                            copyToClipboard("destinationTag");
                        }}>content_copy</i>
                    </div>
                    <span className={"crypto-address-tag-info"}>
                        {t("payments.destination-tag-info")}
                    </span>
                </>
            )}
            {copied && (
                <div className="crypto-copy-notification">
                    {t("forms.address-copied")}
                </div>
            )}
            {tagCopied && (
                <div className="crypto-copy-notification">
                    {t("forms.tag-copied")}
                </div>
            )}
            {props.generateNew  && (
                <div>
                    <button className={"deposit-icon-link"} onClick={()=> props.initDeposit?.(false)}>
                        <Icon name="lightning" size={20} />
                        <span>{t("payments.generate-new-address")}</span>
                    </button>
                </div>
            )}
        </div>
    )
}



class CryptoQR extends React.Component<CryptoQRProps, {data? : string}>{
    constructor(props : CryptoQRProps) {
        super(props);
        this.state = { }
    }
    componentDidMount(): void {
        QRCode.toDataURL(this.props.address).then( d =>{
            this.setState({data : d});
        })
    }
    render() {
        if(!this.state.data) {
            return <span></span>
        }
        return  <img alt={"crypto"} src={this.state.data} />
    }

}

const mapStateToProps = (app:AppState) => {
    return(
        {
            currencies : app.user.user && app.user.user.currencies
        }
    )
}

const mapDispatchToProps = (dispatch : Dispatch) => {
    return {
        initDeposit : (generateNewAddress : boolean) => dispatch(initDeposit(generateNewAddress) as any)
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CryptoDeposit as any) as any;